var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElOpening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H12C13.1046 0 14 0.895431 14 2V12C14 13.1046 13.1046 14 12 14H10V0Z",
    fill: "#449FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H4V14H2C0.895431 14 0 13.1046 0 12V2Z",
    fill: "#449FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElOpening);
export default __webpack_public_path__ + "static/media/el-opening.4cd9cd4f9cbc78909233bdaafc042fdf.svg";
export { ForwardRef as ReactComponent };